import { Component } from '@angular/core';
import { Customer, CustomerCurrent } from '../data/customer';
import { Dealer } from '../data/dealer';
import { CustomerService } from '../services/customer.service';
import { DealerService } from '../services/dealer.service';
import { FuncsService } from '../services/funcs.service';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-auto-login',
  templateUrl: './auto-login.component.html',
  styleUrls: ['./auto-login.component.css'],
  standalone: false
})
export class AutoLoginComponent {
  username = "";
  token = "";

  constructor(
    private customerService: CustomerService,
    private dealerService: DealerService,
    private route: ActivatedRoute,
    private router: Router,
    private funcs: FuncsService
  ) { }

  ngOnInit(): void {
    this.username = this.route.snapshot.queryParamMap.get('username') || '';
    this.token = this.route.snapshot.queryParamMap.get('token') || '';

    this.checkPw();
  }

  checkPw(): void {
    this.customerService.autoLoginVerify(this.username, this.token).subscribe(customer => {
      if (customer && customer.authenticated === "Y") {
        this.funcs.setCustomer(customer);
        if (CustomerCurrent.role == "DEALER" || CustomerCurrent.role == "INT_DEALER") {
          this.dealerService.getDealer(CustomerCurrent.pa_code).subscribe(dealer => {
            this.funcs.setDealer(dealer);
            this.router.navigateByUrl('/status-enrolled');
          });
        } else if (CustomerCurrent.role === "FLEET") {
          this.dealerService.getFleetDealer(CustomerCurrent.pa_code).subscribe(dealer => {
            this.funcs.setDealer(dealer);
            this.router.navigate(['/status-enrolled'], {
              queryParams: { ref: 'fleet' },
            });
          });
        }
        if (this.funcs.isAdminRole(CustomerCurrent.role)) {
          this.router.navigateByUrl('/admin-home');
        }
      } else {
        // clear storage
        this.funcs.setCustomer(<Customer>{});
        this.funcs.setDealer(<Dealer>{});
        this.router.navigateByUrl('/');
      }
    });
  }
}
